// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__nLq0x","containerItemsCenter":"Skeleton_containerItemsCenter__3yl2F"};